<template>
  <div>
setting
  </div>
</template>
<script>
export default {
  name: 'Setting',
  data () {
    return {

    }
  },
  mounted () {

  },
  computed: {

  },
  methods: {

  }
}
</script>
<style scoped>

</style>
